import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { postTypeApi } from "../api/postTypeApi";
import { PAGINATION } from "../constants/common";

export const usePostTypes = (params) => {
  const queryKey = ["/post-types", params];
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: async () => await postTypeApi.getAll(params),
  });

  const create = useMutation({
    mutationFn: async (body) => await postTypeApi.create(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const update = useMutation({
    mutationFn: async (body) => await postTypeApi.update(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const remove = useMutation({
    mutationFn: async (id) => await postTypeApi.remove(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination || PAGINATION,
    loading: isLoading,
    error,
    create,
    update,
    remove,
  };
};
